// @flow
import * as React from 'react'
import { FormattedMessage } from 'mz-intl'
import type { Input, Meta } from 'mz-ui-kit/core/BaseField'
import SpecialCreditCardItem from '../SpecialCreditCardItem'
import messages from '../messages.intl'
import { PROVIDER_OPTION_ID, PAY_WITH_OPTION } from '../constants'

// Types
export type Props = {
  input: Input,
  meta: Meta,
}

// Constants
const CHARGE_PROVIDER_VALUE = {
  type: PAY_WITH_OPTION,
  option: { id: PROVIDER_OPTION_ID },
}

/**
 * General reponsive card elemenent for showing payment option
 * @param  {Object} props.option   A payment option object
 * @return {React.Element}
 */
const ChargeProviderMethod = (props: Props) => (
  <SpecialCreditCardItem
    {...props}
    displayName={<FormattedMessage message={messages.USE_PROVIDER_CARD} />}
    activeValue={CHARGE_PROVIDER_VALUE}
  />
)

export default ChargeProviderMethod
